<template>
  <div
    v-if="show_condition"
    class="acceptors"
    data-qa="acceptors-list">
    <v-skeleton-loader
      v-if="with_loading && (!acceptors || !acceptors.length ) && !only_status && !no_acceptors && !item.acceptors "
      :boilerplate="false"
      class="flex flex-wrap"
      :tile="false"
      type="avatar, sentences"
      width="200px"/>
    <StatusChip
      v-else-if="no_acceptors && (!acceptors || !acceptors.length )"
      :data-qa="`${dataQa}-status-chip`"
      :status="no_acceptors"/>
    <sPopover
      v-else-if="acceptors && acceptors.length"
      popper-class="menu acceptor-list"
      trigger="hover"
      width="auto">
      <div
        slot="reference"
        :class="className">
        <StatusChip
          v-if="only_status && main_people"
          :data-qa="`${dataQa}-status-chip`"
          :name="mainStatusLabel"
          :status="mainStatus"/>
        <template
          v-else>
          <PersonWithStatus
            :avatars="sorted"
            :data-qa="`${dataQa}-person-with-status`"
            :name="mainStatusLabel"
            :status="mainStatus"
            :status-name="mainStatusLabel"
            :tender-id="item.tenderId"
            :users="main_people"
            :with_photo="useAvatar"
            :without-order="stageAgreement"
            without_tooltip
            @click-info="showInfo"/>
        </template>
      </div>
      <div class="pa-4 acceptors-list">
        <template v-if="stageAgreement">
          <StageAgreement
            v-for="(stage, stageIndex) in stages"
            :key="`stage-${stageIndex}`"
            :stage="stage"
            @click-info="showInfo"/>
        </template>
        <template v-else>
          <PersonWithStatus
            v-for="(acceptor, n) in sorted"
            :key="n"
            class="pb-3 px-0"
            :data-qa="`${dataQa}-person-with-status`"
            show_additional
            :status="acceptor.status"
            :status-name="acceptor.statusTitle"
            :tender-id="item.tenderId"
            :user="acceptor"
            with_photo
            :without-order="stageAgreement"
            without_tooltip
            @click-info="showInfo"/>
        </template>
      </div>
    </sPopover>
    <sModal
      :mask-closable="false"
      :title="$t('Tenders.acceptorHistory')"
      :value="!!acceptorData"
      @close="acceptorData = null">
      <SpilkaFormioMF
        v-if="acceptorData && acceptorData.version"
        class="ml-2"
        disabled
        :form-params="acceptorData"
        :hide-submit="true"/>
      <SpilkaFormioMFOld
        v-else-if="acceptorData"
        class="ml-2"
        :form-params="acceptorData"
        :hide-submit="true"/>
      <div
        key="footer"
        slot="footer">
        <sButton
          data-qa="btn-close"
          type="text"
          @click="acceptorData = null">
          {{ $t('Common.Close') }}
        </sButton>
      </div>
    </sModal>
  </div>
</template>
<script>
import SpilkaFormioMF from 'components/common/SpilkaFormioMF.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import StageAgreement from 'components/agreement/StageAgreement.vue'
import SpilkaFormioMFOld from 'components/common/SpilkaFormioMFOld.vue'
import PersonWithStatus from 'components/common/blocks/PersonWithStatus.vue'

import { modalMixin } from 'mixins'
const sortBlocks = ['canceled', 'success', 'decline', 'queued', 'waiting']

/**
 * Выпадалка согласовантов
 */
export default {
  name: 'listOfAcceptors',
  mixins: [modalMixin],
  data() {
    return {
      acceptorData: null,
      loading: false,
      no_acceptors: '',
      mainStatusLabel: null,
      mainStatus: '',
      acceptorsBlocks: {
        canceled: [],
        success: [],
        decline: [],
        queued: [],
        waiting: [],
      },
      sorted: [],
    }
  },
  props: {
    className: String,
    acceptors: Array,
    only_status: Boolean,
    item: Object,
    with_loading: Boolean,
    dataQa: {
      type: String,
      default: 'list-of-acceptors'
    },
    stages: {
      type: Array
    },
    useAvatar: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.loadAccept()
    this.$root.$on('tenderUpdateAgreements', this.checkNeedUpdate)
  },
  async beforeDestroy() {
    this.$root.$off('tenderUpdateAgreements', this.checkNeedUpdate)
  },
  updated() {
    this.$nextTick(function () {
      this.$emit('updated')
    })
  },
  computed: {
    main_people() {
      if (!this.acceptors?.length) {
        return
      }
      //this.getUsers()
      let result = this.acceptorsBlocks.waiting.length ? this.acceptorsBlocks.waiting :
        this.acceptorsBlocks.decline.length ? this.acceptorsBlocks.decline :
          this.acceptorsBlocks.success.length ? this.acceptorsBlocks.success :
            this.acceptorsBlocks.queued.length ? this.acceptorsBlocks.queued :
              this.acceptorsBlocks.canceled.length ? this.acceptorsBlocks.canceled : []

      if (result[0]?.statusTitle) {
        this.$set(this, 'mainStatusLabel', result[0]?.statusTitle)
      } else {
        this.$set(this, 'mainStatusLabel', null)
      }
      this.$set(this, 'mainStatus', result[0]?.status)
      return result.map(el => el.user || el)
    },
    show_condition() {
      return (this.with_loading && !this.acceptors?.length && !this.only_status && !this.no_acceptors && !this.item?.acceptors )
        || (this.no_acceptors && !this.acceptors?.length)
        || this.acceptors?.length
    },
    stageAgreement() {
      return !!(this.stages && this.stages.length)
    }
  },
  methods: {
    showInfo(acceptorData) {
      this.acceptorData = acceptorData
    },
    checkNeedUpdate(value) {
      if (this.item.tenderId === value.tenderId) {
        this.$emit('updateAgreements')
        this.loadAccept()
      }
    },
    filterAcceptors() {
      sortBlocks.forEach((sortBlock) => {
        this.$set(this.acceptorsBlocks, sortBlock, [])
      })
      const fioSort = (a, b) => {
        return new Intl.Collator('ua').compare(
          (b.firstName || b.fio)?.toLowerCase(), (a.firstName || a.fio)?.toLowerCase()
        )
      }
      const sortStage = (a, b) => {
        return (a.stageNumber - b.stageNumber) || (a.aggreeNumber - b.aggreeNumber)
      }

      this.$_.cloneDeep(this.acceptors)
        .sort((a, b) =>
          this.stages?.length ? sortStage(a, b) : fioSort(a, b)
        )
        .forEach(el => {
          this.acceptorsBlocks[el?.status?.toLowerCase()].push(Object.freeze(el))
        })
      this.sorted = []
      if (this.stages?.length) {
        this.sorted = this.acceptors
      } else {
        sortBlocks.forEach((sortBlock) => {
          this.sorted.push(
            ...this.acceptorsBlocks[sortBlock].filter(i => i.isAdditional),
            ...this.acceptorsBlocks[sortBlock].filter(i => !i.isAdditional),
          )
        })
      }
    },
    loadAccept(val) {
      val ||= this.acceptors
      if ( this.item?.status == 'П' || this.item?.state == 'П') {
        this.no_acceptors = 'Draft'
      } else if ( val?.length) {
        this.filterAcceptors()
      }
    },
  },
  watch: {
    acceptors(val) {
      this.loadAccept(val)
    }
  },
  components: {
    StatusChip,
    StageAgreement,
    SpilkaFormioMF,
    PersonWithStatus,
    SpilkaFormioMFOld,
  }
}
</script>
<style>
.acceptor-list {
  max-height: 60%;
  overflow: auto;
}
</style>
